import { Injectable } from '@angular/core';
import { User } from './user.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

const BACKEND_URL = environment.apiUrl + '/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private isAuthenticated = false;
  private token: string;
  private tokenTimer: any;
  private userId: string;
  private userName: string;
  private email: string;
  private level: string;
  private error = '';
  private authStatusListner = new Subject<boolean>();
  constructor(private http: HttpClient, private router: Router) { }

  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getUserId() {
    return this.userId;
  }

  getUserName() {
    return this.userName;
  }

  getUserLevel() {
    return this.level;
  }

  getUserEmail() {
    return this.email;
  }

  signup(user: User) {
    return this.http.post(BACKEND_URL + '/signup', user);
  }

  login(email: string, password: string) {
    const authData = { email: email, password: password };
    this.http.post<{ token: string, expiresIn: number, id: string, name: string, email: string, level: string }>(
      BACKEND_URL + "/login", authData)
      .subscribe(response => {
        const token = response.token;
        this.token = token;
        if (token) {
          const expiresInDuration = response.expiresIn;
          this.setAuthTimer(expiresInDuration);
          this.isAuthenticated = true;
          this.userId = response.id;
          this.userName = response.name;
          this.email = response.email;
          this.level = response.level;
          this.authStatusListner.next(true);
          const now = new Date();
          const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);
          //console.log(expirationDate);
          this.saveAuthData(token, expirationDate, this.userId, this.userName, this.email, this.level);
          this.router.navigate(['/']);
        }
      }, error => {
        this.error = error.error.message;
        this.authStatusListner.next(false);
      });
  }

  getError() {
    return this.error;
  }

  getAuthStatusListner() {
    return this.authStatusListner.asObservable();
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.userId = authInformation.userId;
      this.userName = authInformation.userName;
      this.email = authInformation.email;
      this.level = authInformation.level;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListner.next(true);
    }
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.level = null;
    this.authStatusListner.next(false);
    clearInterval(this.tokenTimer);
    this.clearAuthData();
    this.userId = null;
    this.userName = null;
    this.email = null;
    this.router.navigate(['/login']);
  }

  private setAuthTimer(duration: number) {
    console.log("Setting Timer " + duration);
    this.tokenTimer = setTimeout(() => {
      this.logout();
    }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date, userId: string, userName: string, email: string, level: string) {
    localStorage.setItem('token', token);
    localStorage.setItem('expiration', expirationDate.toISOString());
    localStorage.setItem('userId', userId);
    localStorage.setItem('userName', userName);
    localStorage.setItem('email', email);
    localStorage.setItem('level', level);
  }

  private clearAuthData() {
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('email');
    localStorage.removeItem('level');
  }

  private getAuthData() {
    const token = localStorage.getItem("token");
    const expirationDate = localStorage.getItem("expiration");
    const userId = localStorage.getItem("userId");
    const userName = localStorage.getItem("userName");
    const email = localStorage.getItem("email");
    const level = localStorage.getItem("level");
    if (!token || !expirationDate) {
      return;
    }
    return {
      token: token,
      expirationDate: new Date(expirationDate),
      userId: userId,
      userName: userName,
      email: email,
      level: level
    }
  }

  public getAllServerProcess() {
    return this.http.get(BACKEND_URL + '/getProcess');
  }
}